export default __webpack_public_path__ + "1f68e6e7c6b147066669655558de6a42.png";